module.exports = __webpack_public_path__ + "media/images/visit-us-2-m-a296d2f8dace7777ac9241217ac689aa.jpg";